import React, { useEffect, useState } from "react";
import Icon from "@mdi/react";
import { mdiHistory, mdiMagnify } from "@mdi/js";
import { Dropdown, Table } from "react-bootstrap";
import { DateTimePicker } from "react-widgets";
import moment from "moment";
import NumberFormat from "react-number-format";

import { getUserLogin } from "utils/utils";
import { pushNotification } from "utils/notifications";
import DatHangDaiLyApi from "service/datHangDaiLyApi";
import DatHangApi from "service/DatHang/DatHangApi";
import Pagination from "react-js-pagination";
import FullScreenLoading from "../loading/FullScreenLoading";

export default function GiaoDich() {
  const listTime = [
    { key: "1", value: "Hôm nay" },
    { key: "2", value: "Hôm qua" },
    { key: "3", value: "Tuần này" },
    { key: "4", value: "Tuần trước" },
    { key: "5", value: "Tháng này" },
    { key: "6", value: "Tháng trước" },
    { key: "7", value: "Quý này" },
    { key: "8", value: "Quý trước" },
    { key: "9", value: "Năm này" },
    { key: "10", value: "Năm trước" },
    { key: "11", value: "Tuỳ chỉnh thời gian" },
  ];

  const initSearch = {
    customerId: 0,
    typeDate: "1",
    tungay: moment().format("YYYY-MM-DD"),
    denngay: moment().format("YYYY-MM-DD"),
    pageIndex: 1,
    pageSize: 20,
  };

  const initList = {
    iTotal: 0,
    List: [],
    TongPhatSinh: 0,
    NoDauKy: 0,
    NoCuoiKy: 0,
  };

  const [dataSearch, setDataSearch] = useState(initSearch);
  const [listDanhSach, setListDanhSach] = useState(initList);
  const [isStartProcess, setIsStartProcess] = useState(false);

  const [selectedTime, setSelectedTime] = useState({
    key: "1",
    value: "Hôm nay",
  });

  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [dateFrom, setDateFrom] = useState(new Date());
  const [dateTo, setDateTo] = useState(new Date());

  useEffect(() => {
    loadThongTinKhachHang();
  }, []);

  const loadThongTinKhachHang = () => {
    DatHangApi.getChiTietKhachHangById(getUserLogin().UserName)
      .then((response) => {
        if (response.status === 200) {
          const customerId = response.data.CustomerID || 0;

          const search = {
            ...dataSearch,
            customerId: customerId,
          };

          setDataSearch(search);
          loadData(search);
        }
      })
      .catch((err) => {
        console.log("Lỗi lấy thông tin khách hàng", err);
        pushNotification(
          "Lỗi lấy thông tin khách hàng",
          "error",
          "TOP_RIGHT",
          2000,
        );
      });
  };

  const getDateByType = (typeDate) => {
    let tungay = moment();
    let denngay = moment();

    switch (typeDate) {
      case "1":
        tungay = moment();
        denngay = moment();
        break;

      case "2":
        tungay = moment().subtract(1, "days");
        denngay = moment().subtract(1, "days");
        break;

      case "3":
        tungay = moment().startOf("week");
        denngay = moment().endOf("week");
        break;

      case "4":
        tungay = moment().subtract(1, "weeks").startOf("week");
        denngay = moment().subtract(1, "weeks").endOf("week");
        break;

      case "5":
        tungay = moment().startOf("month");
        denngay = moment().endOf("month");
        break;

      case "6":
        tungay = moment().subtract(1, "months").startOf("month");
        denngay = moment().subtract(1, "months").endOf("month");
        break;

      case "7":
        tungay = moment().startOf("quarter");
        denngay = moment().endOf("quarter");
        break;

      case "8":
        tungay = moment().subtract(1, "quarters").startOf("quarter");
        denngay = moment().subtract(1, "quarters").endOf("quarter");
        break;

      case "9":
        tungay = moment().startOf("year");
        denngay = moment().endOf("year");
        break;

      case "10":
        tungay = moment().subtract(1, "years").startOf("year");
        denngay = moment().subtract(1, "years").endOf("year");
        break;

      case "11":
        tungay = moment(dateFrom);
        denngay = moment(dateTo);
        break;

      default:
        tungay = moment();
        denngay = moment();
        break;
    }

    return {
      tungay: tungay.format("YYYY-MM-DD"),
      denngay: denngay.format("YYYY-MM-DD"),
    };
  };

  const loadData = (search = dataSearch) => {
    if (!search.customerId || Number(search.customerId) === 0) return;

    setIsStartProcess(true);

    DatHangDaiLyApi.listGiaoDich(
      search.customerId,
      search.tungay,
      search.denngay,
      search.pageIndex,
      search.pageSize,
    )
      .then((response) => {
        setIsStartProcess(false);

        if (response.status === 200) {
          const list = response.data?.List || [];

          setListDanhSach({
            List: list,
            iTotal: response.data?.TongBanGhi,
            TongPhatSinh: response.data?.TongPhatSinh || 0,
            NoDauKy: response.data?.NoDauKy || 0,
            NoCuoiKy: response.data?.NoCuoiKy || 0,
          });
        } else {
          pushNotification(response.data, "error", "TOP_RIGHT", 2000);
        }
      })
      .catch((err) => {
        setIsStartProcess(false);
        console.log("Lỗi lấy danh sách giao dịch", err);
        pushNotification(
          "Lỗi lấy danh sách giao dịch",
          "error",
          "TOP_RIGHT",
          2000,
        );
      });
  };

  const handleSelectTime = (key, value) => {
    setSelectedTime({ key, value });

    if (key === "11") {
      setShowTimeDropdown(true);
      return;
    }

    setShowTimeDropdown(false);

    const dateSearch = getDateByType(key);

    const search = {
      ...dataSearch,
      typeDate: key,
      tungay: dateSearch.tungay,
      denngay: dateSearch.denngay,
      pageIndex: 1,
    };

    setDataSearch(search);
  };

  const onSearch = () => {
    const dateSearch = getDateByType(selectedTime.key);

    const search = {
      ...dataSearch,
      typeDate: selectedTime.key,
      tungay: dateSearch.tungay,
      denngay: dateSearch.denngay,
      pageIndex: 1,
    };

    setDataSearch(search);
    loadData(search);

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const handlePageChange = (pageNumber) => {
    const search = {
      ...dataSearch,
      pageIndex: pageNumber,
    };

    setDataSearch(search);
    loadData(search);

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const getValue = (item, fields, defaultValue = "") => {
    for (let i = 0; i < fields.length; i++) {
      if (typeof item[fields[i]] !== "undefined" && item[fields[i]] !== null) {
        return item[fields[i]];
      }
    }

    return defaultValue;
  };

  return (
    <div className="giaodich-page">
      {isStartProcess && <FullScreenLoading />}
      <div className="giaodich-header-v2">
        <div className="giaodich-title">
          <Icon path={mdiHistory} size={1.2} />
          <span>Giao dịch</span>
        </div>

        <div className="giaodich-time-search giaodich-time-pill">
          <Dropdown
            show={showTimeDropdown}
            onToggle={(show) => setShowTimeDropdown(show)}
          >
            <div className="giaodich-time-box">
              <Dropdown.Toggle className="giaodich-time-toggle">
                <span>{selectedTime.value}</span>
              </Dropdown.Toggle>

              <button
                type="button"
                className="giaodich-search-icon-btn"
                onClick={onSearch}
              >
                <Icon path={mdiMagnify} size={1.2} />
              </button>
            </div>

            <Dropdown.Menu
              className={selectedTime.key === "11" ? "has-custom-time" : ""}
            >
              <Table borderless style={{ marginBottom: 0 }}>
                <tbody>
                  <tr>
                    <td>
                      {listTime.map((item) => (
                        <Dropdown.Item
                          key={item.key}
                          eventKey={item.key}
                          className={
                            selectedTime.key === item.key
                              ? item.key === "11"
                                ? "active-custom"
                                : "active-time"
                              : ""
                          }
                          onSelect={() =>
                            handleSelectTime(item.key, item.value)
                          }
                        >
                          {item.value}
                        </Dropdown.Item>
                      ))}
                    </td>

                    {selectedTime.key === "11" && (
                      <td className="don-date-custom-cell">
                        <div className="don-date-custom">
                          <div>
                            <label>Từ ngày</label>

                            <DateTimePicker
                              format="DD/MM/YYYY"
                              time={false}
                              value={dateFrom}
                              onChange={(value) => setDateFrom(value)}
                              culture="vi"
                            />
                          </div>

                          <div>
                            <label>Đến ngày</label>

                            <DateTimePicker
                              format="DD/MM/YYYY"
                              time={false}
                              value={dateTo}
                              onChange={(value) => setDateTo(value)}
                              culture="vi"
                            />
                          </div>

                          <div className="don-date-custom-actions">
                            <button
                              type="button"
                              onClick={() => {
                                handleSelectTime("1", "Hôm nay");
                              }}
                            >
                              Huỷ
                            </button>

                            <button
                              type="button"
                              onClick={() => setShowTimeDropdown(false)}
                            >
                              Áp dụng
                            </button>
                          </div>
                        </div>
                      </td>
                    )}
                  </tr>
                </tbody>
              </Table>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="giaodich-summary">
        <div className="giaodich-summary-item">
          <span>Tổng phát sinh:</span>
          <b>
            <NumberFormat
              value={listDanhSach.TongPhatSinh}
              displayType={"text"}
              thousandSeparator={true}
            />
          </b>
        </div>

        <div className="giaodich-summary-item center">
          <span>Nợ đầu kỳ:</span>
          <b>
            <NumberFormat
              value={listDanhSach.NoDauKy}
              displayType={"text"}
              thousandSeparator={true}
            />
          </b>
        </div>

        <div className="giaodich-summary-item right-item">
          <span>Nợ cuối kỳ:</span>
          <b>
            <NumberFormat
              value={listDanhSach.NoCuoiKy}
              displayType={"text"}
              thousandSeparator={true}
            />
          </b>
        </div>
      </div>

      <div className="giaodich-table-wrap">
        <table className="giaodich-table">
          <thead>
            <tr>
              <th>Mã đơn hàng</th>
              <th>Mã PO</th>
              <th>Thời điểm</th>
              <th className="text-right">Tiền hàng</th>
              <th className="text-right">Điều chỉnh công nợ</th>
              <th className="text-right">Tiền thanh toán</th>
              <th className="text-right">Phát sinh</th>
              <th className="text-right">Nợ</th>
              <th>Ghi chú</th>
            </tr>
          </thead>

          <tbody>
            {listDanhSach.List && listDanhSach.List.length > 0 ? (
              listDanhSach.List.map((item, index) => (
                <tr key={index}>
                  <td>{item.MaDonHang}</td>

                  <td>{item.MaPO}</td>

                  <td>
                    {item.ThoiGian
                      ? moment(item.ThoiGian).format("DD/MM/YYYY HH:mm")
                      : ""}
                  </td>

                  <td className="text-right">
                    <NumberFormat
                      value={item.TienHang}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </td>

                  <td className="text-right">
                    <NumberFormat
                      value={item.DieuChinhCongNo}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </td>

                  <td className="text-right">
                    <NumberFormat
                      value={item.TienThanhToan}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </td>

                  <td className="text-right">
                    <NumberFormat
                      value={item.PhatSinh}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </td>

                  <td className="text-right">
                    <NumberFormat
                      value={item.No}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </td>

                  <td>{item.GhiChu}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="giaodich-empty">
                  {isStartProcess ? "Đang tải dữ liệu..." : "Không có dữ liệu"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="paggination-ver2 text-center pagination-Main justify-content-center">
        {listDanhSach.iTotal > 0 && (
          <>
            <div className="total-page">
              Tổng số {listDanhSach.iTotal} bản ghi
            </div>

            <Pagination
              activePage={dataSearch.pageIndex}
              itemsCountPerPage={dataSearch.pageSize}
              totalItemsCount={listDanhSach.iTotal}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideNavigation={true}
              itemClass="cssPage-item"
              linkClass="cssPageLink"
              activeClass="cssActiveClass"
            />
          </>
        )}
      </div>
    </div>
  );
}
